"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notificationApiClient = void 0;
const data_lib_1 = require("@redbox-ruby/data-lib");
function notificationApiClient(networkClient) {
    return {
        listMessages: (params, query, config) => {
            return networkClient.listHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/users/${params.id}/messages`, query, config);
        },
        deleteMessages: (params, body) => {
            return networkClient.deleteHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/users/${params.id}/messages`, body);
        },
        deleteMessage: (params) => {
            return networkClient.deleteHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/users/${params.userId}/messages/${params.notificationId}`);
        },
        setUserNotificationSettings: (params, body) => {
            return networkClient.putHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/notifications/users/${params.userId}/settings`, body);
        },
        getUserTeamNotificationSettings: (params) => {
            return networkClient.getHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/notifications/users/${params.userId}/teams/${params.teamId}/settings`);
        },
        setUserTeamNotificationSettings: (params, body) => {
            return networkClient.putHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/notifications/users/${params.userId}/teams/${params.teamId}/settings`, body);
        },
        getUserNotificationSettings: (params) => {
            return networkClient.getHttp(data_lib_1.ACCOUNTS_WEB_SERVICE, `/api/v2/accounts/notifications/users/${params.userId}/settings`);
        },
    };
}
exports.notificationApiClient = notificationApiClient;
